import { miscHelpers, routerHelpers } from '@approvalmax/utils';
import { selectors } from 'modules/common';
import { domain } from 'modules/data';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { routingService } from 'services/routing';

import { showLoginModule } from '../actions';
import { LOGIN_PAGE_ID } from '../config';

const useLoginPageData = () => {
    const dispatch = useDispatch();
    const authenticated = useSelector(selectors.session.authenticated);
    const search = useLocation().search;
    const postAction = routerHelpers.getParamAsString(search, 'postAction', '');
    const app = routerHelpers.getParamAsString(search, 'app', '');
    const email = routerHelpers.getParamAsString(search, 'email', '');

    useEffect(() => {
        if (authenticated) {
            if (postAction) {
                routingService.push(postAction);
            } else {
                routingService.replaceToDefaultPath();
            }
        } else {
            dispatch(
                showLoginModule({
                    email,
                    app: miscHelpers.castToEnum(domain.SsoLoginApplication, app),
                    postAction,
                    innerPageId: LOGIN_PAGE_ID,
                })
            );
        }
    }, [app, authenticated, dispatch, email, postAction]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const metaDescriptionElement = document.createElement('meta');

            metaDescriptionElement.setAttribute('name', 'description');
            metaDescriptionElement.setAttribute('content', 'Login to your ApprovalMax account');

            const htmlHeadElement = document.querySelector('head');

            if (htmlHeadElement) {
                htmlHeadElement.appendChild(metaDescriptionElement);
            }

            return () => {
                if (htmlHeadElement) {
                    htmlHeadElement.removeChild(metaDescriptionElement);
                }
            };
        }

        return;
    }, []);
};

export default useLoginPageData;
